import React from "react";
import Navbar from "../components/NavBar";
import Footer from "../components/Footer";

const FavoritesPage = () => {
  return (
    <div>
      <Footer />
    </div>
  );
};

export default FavoritesPage;
